import { useI18n } from "@/lib/i18n";
import { Languages } from "lucide-react";
import { FloatingButton } from "@/components/common/FloatingButton";

export const LanguageSwitch = () => {
  const { language, setLanguage } = useI18n();

  const toggleLanguage = () => {
    setLanguage(language === "zh" ? "en" : "zh");
  };

  return (
    <FloatingButton
      position="top-left"
      onClick={toggleLanguage}
      buttonClassName="w-fit justify-between"
    >
      <Languages className="h-3 w-3" />
      <span className="font-medium">{language === "zh" ? "中" : "EN"}</span>
    </FloatingButton>
  );
};
